// 🔐 MODAL SENHA MASTER - Liberação de Visualização de Senhas
// Criado em: 15/01/2026
// Pede senha master 'adm@master2026' para descriptografar senhas

import React, { useState } from 'react';
import './ModalSenhaMaster.css';

// IMPORTANTE: Configure a variável de ambiente REACT_APP_SENHA_MASTER no .env
const SENHA_MASTER_CORRETA = process.env.REACT_APP_SENHA_MASTER || 'ALTERE_ESTA_SENHA_MASTER';

function ModalSenhaMaster({ isOpen, onClose, onSenhaMasterCorreta }) {
  const [senhaMaster, setSenhaMaster] = useState('');
  const [erro, setErro] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    console.log('🔐 [MODAL] Verificando senha master...');
    
    if (senhaMaster === SENHA_MASTER_CORRETA) {
      console.log('✅ [MODAL] Senha master correta! Liberando visualização...');
      setErro('');
      onSenhaMasterCorreta(SENHA_MASTER_CORRETA);
      handleClose();
    } else {
      console.log('❌ [MODAL] Senha master incorreta!');
      setErro('Senha master incorreta! Acesso negado.');
      setSenhaMaster('');
    }
  };

  const handleClose = () => {
    setSenhaMaster('');
    setErro('');
    setMostrarSenha(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-senha-master-overlay">
      <div className="modal-senha-master-content">
        <div className="modal-senha-master-header">
          <h3>🔐 Autenticação Administrativa</h3>
          <button className="btn-fechar-modal" onClick={handleClose}>
            ✕
          </button>
        </div>

        <div className="modal-senha-master-body">
          <div className="aviso-seguranca">
            <i className="fas fa-shield-alt"></i>
            <p>
              <strong>Acesso Restrito:</strong> Para visualizar as senhas dos usuários,
              é necessário fornecer a senha master administrativa.
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group-senha-master">
              <label htmlFor="senhaMaster">
                <i className="fas fa-key"></i> Senha Master:
              </label>
              <div className="input-senha-wrapper">
                <input
                  id="senhaMaster"
                  type={mostrarSenha ? 'text' : 'password'}
                  value={senhaMaster}
                  onChange={(e) => setSenhaMaster(e.target.value)}
                  placeholder="Digite a senha master"
                  autoFocus
                  autoComplete="off"
                  className={erro ? 'input-erro' : ''}
                />
                <button
                  type="button"
                  className="btn-toggle-senha"
                  onClick={() => setMostrarSenha(!mostrarSenha)}
                  title={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                >
                  <i className={`fas fa-eye${mostrarSenha ? '-slash' : ''}`}></i>
                </button>
              </div>
              
              {erro && (
                <div className="mensagem-erro">
                  <i className="fas fa-exclamation-triangle"></i>
                  {erro}
                </div>
              )}
            </div>

            <div className="modal-senha-master-footer">
              <button type="submit" className="btn-confirmar" disabled={!senhaMaster}>
                <i className="fas fa-unlock"></i> Liberar Senhas
              </button>
              <button type="button" className="btn-cancelar-modal" onClick={handleClose}>
                <i className="fas fa-times"></i> Cancelar
              </button>
            </div>
          </form>

          <div className="dica-seguranca">
            <i className="fas fa-info-circle"></i>
            <small>
              Esta senha é diferente das credenciais de login. 
              Contate o administrador do sistema caso não possua acesso.
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalSenhaMaster;
